import { Phone, MapPin } from "lucide-react";

export const TopBar = ({ settings, lang, onLangChange }) => {
  return (
    <div className="bg-emerald-950 text-emerald-100 text-xs py-2 px-4 border-b border-emerald-900/60">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-2">
        {/* Arabic Bismillah Center/Left */}
        <div className="flex items-center gap-3">
          <span className="font-arabic text-sm text-amber-300 font-medium tracking-wide">
            {settings?.bismillah_header}
          </span>
          <span className="hidden lg:inline text-emerald-400/40">|</span>
          <span className="hidden lg:flex items-center gap-1.5 text-emerald-200/90 text-[11px]">
            <MapPin className="w-3.5 h-3.5 text-amber-400 shrink-0" />
            {lang === "bn" ? settings?.address_bn : settings?.address}
          </span>
        </div>

        {/* Right Info: Phone & Language Toggle */}
        <div className="flex items-center gap-4">
          <a
            href={`tel:${(settings?.phone || "").replace(/[^0-9+]/g, "")}`}
            className="flex items-center gap-1 text-emerald-200 hover:text-white transition-colors"
          >
            <Phone className="w-3.5 h-3.5 text-amber-400" />
            <span>{settings?.phone || "+880 1812-345678"}</span>
          </a>

          {/* Dual Language Switcher */}
          <div className="flex items-center bg-emerald-900/80 rounded-full p-0.5 border border-emerald-800">
            <button
              onClick={() => onLangChange("bn")}
              className={`px-2.5 py-0.5 text-[11px] font-medium rounded-full transition-all ${
                lang === "bn"
                  ? "bg-amber-400 text-emerald-950 font-bold shadow-xs"
                  : "text-emerald-300 hover:text-white"
              }`}
            >
              বাংলা
            </button>
            <button
              onClick={() => onLangChange("en")}
              className={`px-2.5 py-0.5 text-[11px] font-medium rounded-full transition-all ${
                lang === "en"
                  ? "bg-amber-400 text-emerald-950 font-bold shadow-xs"
                  : "text-emerald-300 hover:text-white"
              }`}
            >
              English
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
